<form
    class="flex w-96 flex-col p-5"
    [formGroup]="form">
    <h1 class="mb-5 text-center text-xl">Create offer</h1>
    <mat-form-field>
        <mat-label>Service title</mat-label>
        <input
            matInput
            formControlName="serviceTitle" />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Offer type</mat-label>
        <mat-select formControlName="offerType">
            @for (keyValue of OfferType | appEnumKeyValue; track $index) {
                <mat-option [value]="keyValue.value">{{ keyValue.key }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Advertiser</mat-label>
        <mat-select formControlName="clientId">
            @for (client of data ?? []; track $index) {
                <mat-option [value]="client.id">{{ client.title }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <button
        mat-flat-button
        color="primary"
        [disabled]="form.invalid"
        (click)="close()">
        Submit
    </button>
</form>
